export var now = function () { return Date.now(); };
//# sourceMappingURL=date.js.map